<template>
  <div class="appHeaderAutorized">
    <div class="authorized" @click="authorLink">
      <span class="imgWrap">
      <img src="../assets/images/login_cn.png">
        </span>
      <p class="word" v-if="isUserLogin">로그아웃</p>
      <p class="word" v-else>로그인</p>
    </div>
  <div class="logo">
        <span class="imgWrap">
        <img src="../assets/images/logo_t.png" />
            </span>
    <span class="imgWrap">
            <img src="../assets/images/logo.png" />
        </span>
  </div>
  <div class="uberButton" @click="uberClick">
        <span class="imgWrap">
            <img src="../assets/images/menu.png" />
        </span>
  </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
import EventBus from '../utils/bus'
export default {
  data () {
    return {
      loginCheck: ''
    }
  },
  computed: {
    isUserLogin () {
      return this.$store.getters.IS_LOGIN
    }
  },
  methods: {
    uberClick () {
      EventBus.$emit('addOn')
    },
    logoutUser () {
      this.$store.commit('clearUserName')
      VueCookies.remove('token')
      this.$router.push('/')
    },
    authorLink () {
      if (this.$store.getters.IS_LOGIN) {
        this.logoutUser()
      } else {
        this.$router.push('/login')
      }
    }
  },
  components: {

  },
  beforeDestroy () {
    EventBus.$off('addOn')
  }
}
</script>

<style lang="scss" scoped>
  .appHeaderAutorized {
    background:#2a2a2a;
    .authorized {
      position: absolute;
      top: 22px;
      left: 0;
      padding: 0 15px;
      height: 57px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      span.imgWrap {
        img {

        }
      }
      p.word {
        color: #fff;
        text-align: left;
        font-family: "NotoSansCJKkr", serif;
        font-size: 12px;
        font-weight: normal;
        line-height: 1.5;
        position: inherit;
        bottom: 2px;
        white-space: nowrap;
      }
    }
    .logo {
      margin: 0;
      padding:25px 0 15px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        &:last-of-type {
          margin-left:6.5px;
        }
      }
    }
    .uberButton {
      position: absolute;
      top: 0;
      right: 0;
      padding: 25px 15px 0 0;
      height:79px;
      cursor:pointer;
      span.imgWrap {
        img {
        }
      }
    }
  }
</style>
